import { render, staticRenderFns } from "./contacter-add.vue?vue&type=template&id=bb527c4a&"
import script from "./contacter-add.vue?vue&type=script&lang=js&"
export * from "./contacter-add.vue?vue&type=script&lang=js&"
import style0 from "./contacter-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports